import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { useEffect } from "react";


import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";




import Content from './Views/Content';
import DataProtectionPage from  './Views/DataProtectionPage';
import Footer from './Components/Footer';
import { MantineProvider } from '@mantine/core';
import { TypographyStylesProvider } from '@mantine/core';
import ReportPage from './Views/ReportPage'; // Create this new page component
import ImprintPage from './Views/ImprintPage';
function App() {



/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
CookieConsent.run({

    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        analytics: {}
    },

    language: {
        default: 'en',
        translations: {
            en: {
                consentModal: {
                    title: 'Privacy Settings',
                    description: 'This tool helps you manage consent to third party technologies collecting and processing personal data.',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Manage Individual preferences'
                },
                preferencesModal: {
                    title: 'Manage cookie preferences',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Accept current selection',
                    closeIconLabel: 'Close modal',
                    sections: [
                        {
                            title: 'This website uses cookies.',
                            description: 'We use cookies to personalize content and ads, provide social media features, and analyze traffic on our website. We also share information about your use of our website with our partners for social media, advertising, and analytics. Our partners may combine this information with other data you’ve provided to them or that they have collected through your use of their services.'
                        },
                        {
                            title: 'Strictly Necessary cookies',
                            description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',

                            //this field will generate a toggle linked to the 'necessary' category
                            linkedCategory: 'necessary'
                        },
                        {
                            title: 'Performance and Analytics',
                            description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                            linkedCategory: 'analytics'
                        },
                        {
                            title: 'More information',
                            description: 'For any queries in relation to my policy on cookies and your choices, please <a href="mailto:michael.wang@danaxssert.de">contact us</a> or check our <a href= "https://international-trading.danaxssert.de/data-protection" >Data Protection</a> and <a href= "https://international-trading.danaxssert.de/imprint" >Imprint</a>.' 
                        }
                    ]
                }
            }
        }
    }
});


  

  return (
   <Router> 
    <MantineProvider>
      <TypographyStylesProvider>
       
         <Routes>     
            <Route path="/" element={<Content />} />
            <Route path="/report" element={<ReportPage />} />
            <Route path="/data-protection" element={<DataProtectionPage />} />
             <Route path="/imprint" element={<ImprintPage />} />          
          </Routes>
        <Footer />
      </TypographyStylesProvider>
    </MantineProvider>
</Router> 
  );
}

export default App;
